import { supabase } from '../lib/supabase';

const statToCamelCase = (obj) => {
  if (!obj) return obj;
  return {
    title: obj?.title,
    value: obj?.value,
    change: obj?.change,
    changeType: obj?.change_type,
    trend: obj?.trend,
    icon: obj?.icon,
    iconColor: obj?.icon_color,
    updatedAt: obj?.updated_at,
  };
};

const activityToCamelCase = (obj) => {
  if (!obj) return obj;
  return {
    id: obj?.id,
    type: obj?.activity_type,
    title: obj?.title,
    description: obj?.description,
    user: obj?.user_id, // Will be populated with user name in component
    timestamp: obj?.created_at,
    createdAt: obj?.created_at,
  };
};

export const dashboardService = {
  async getStats() {
    const { data, error } = await supabase?.from('dashboard_stats')?.select('*')?.order('stat_key');

    if (error) throw error;
    return data?.map(statToCamelCase) || [];
  },

  async getActivities() {
    const { data, error } = await supabase?.from('activities')?.select('*')?.order('created_at', { ascending: false })?.limit(10);

    if (error) throw error;
    return data?.map(activityToCamelCase) || [];
  },

  async createActivity(activity) {
    const { data: { user } } = await supabase?.auth?.getUser();
    if (!user) throw new Error('Not authenticated');

    const { data, error } = await supabase?.from('activities')?.insert({
        activity_type: activity?.type,
        title: activity?.title,
        description: activity?.description,
        user_id: user?.id,
      })?.select()?.single();

    if (error) throw error;
    return activityToCamelCase(data);
  },
};
